<slider *ngIf="isPlat"></slider>
<menus></menus>
<products></products>
<mobile></mobile>